//@flow
import { handleMutationError } from "../API"
import type { CreateUserMutation, UpdateUserMutation, User } from "./types"

const handleSubmit = (
  id: ?string,
  createUser: CreateUserMutation,
  updateUser: UpdateUserMutation,
  onSuccess: Function
) => async (user: User) => {
  try {
    await (typeof id === "string" ? updateUser(id, user) : createUser(user))
    onSuccess()
  } catch (mutationError) {
    const errorString: string = mutationError
    handleMutationError(errorString)
  }
}

export default handleSubmit



// WEBPACK FOOTER //
// ./src/Users/handleSubmit.js